module.exports = __webpack_public_path__ + "static/media/img--320x240.9b29229b.9b29229b.jpg";